import { defineStore } from 'pinia';

import AbsenceApi from '@/store/api/system/absence';

/**
 * What every absence screen shares: the holiday calendar per year (fetched
 * once, read by the pickers, the day counter and the gantt) and whether
 * vacation currently waits for approval. The absences themselves are page
 * state: the calendar and a person page read different windows.
 */
export const useAbsenceStore = defineStore('absence', {
    state: () => ({
        holidaysByYear: {},
        approval: null,
    }),

    getters: {
        // date -> name, over every year loaded so far
        holidayNames: (state) => {
            const names = {};
            Object.values(state.holidaysByYear).forEach((holidays) => {
                holidays.forEach((holiday) => {
                    names[holiday.date] = holiday.name;
                });
            });

            return names;
        },
        approvalActive: (state) => !!(state.approval && state.approval.active),
    },

    actions: {
        // Both years around a window, so a span over New Year is counted right.
        loadHolidays(years) {
            const missing = years.filter((year) => !this.holidaysByYear[year]);

            return Promise.all(
                missing.map((year) =>
                    AbsenceApi.fetchPublicHolidays(year).then((holidays) => {
                        this.holidaysByYear = { ...this.holidaysByYear, [year]: holidays };
                    })
                )
            );
        },

        loadApproval() {
            return AbsenceApi.fetchApproval().then((approval) => {
                this.approval = approval;

                return approval;
            });
        },
    },
});
